var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',{staticClass:"navigator"},[_vm._t("default")],2),_vm._v(" "),_c('el-row',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{on:{"update":e=>_vm.$emit('update',e),"delete":e=>_vm.$emit('delete',e),"something-changed":_vm.reloadStaff}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }